import React from 'react';
import Main from './components/Main';
import './index.scss';

const ServiceBusiness = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default ServiceBusiness
